var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 0C8.23976 0 6.2776 0.842851 4.83089 2.34314C3.38418 3.84342 2.57143 5.87824 2.57143 7.99997H0L3.33429 11.4577L3.39429 11.5822L6.85714 7.99997H4.28571C4.28571 6.34974 4.91786 4.7671 6.04307 3.60021C7.16829 2.43332 8.69442 1.77777 10.2857 1.77777C11.877 1.77777 13.4031 2.43332 14.5284 3.60021C15.6536 4.7671 16.2857 6.34974 16.2857 7.99997C16.2857 9.6502 15.6536 11.2328 14.5284 12.3997C13.4031 13.5666 11.877 14.2222 10.2857 14.2222C8.63143 14.2222 7.13143 13.5199 6.05143 12.3911L4.83429 13.6533C5.54698 14.4005 6.39615 14.9929 7.33217 15.3958C8.26819 15.7987 9.27227 16.0041 10.2857 15.9999C12.3317 15.9999 14.2938 15.1571 15.7405 13.6568C17.1872 12.1565 18 10.1217 18 7.99997C18 5.87824 17.1872 3.84342 15.7405 2.34314C14.2938 0.842851 12.3317 0 10.2857 0Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReLoad);
export default __webpack_public_path__ + "static/media/IconReLoad.aecc34a2e131ce10bda79a0fdcc4bafa.svg";
export { ForwardRef as ReactComponent };